<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<h1 class="center">Contents</h1>
<p class="toc2" style="margin-top:60px;"><a href="#/BeyondtheFarthestSuns_3P_MD3">THE VENGING</a></p>
<p class="toc1"><a href="#/BeyondtheFarthestSuns_3P_MD4">PERIHESPERON</a></p>
<p class="toc1"><a href="#/BeyondtheFarthestSuns_3P_MD5">THE FALL OF THE HOUSE OF ESCHER</a></p>
<p class="toc1"><a href="#/BeyondtheFarthestSuns_3P_MD6">THE WAY OF ALL GHOSTS</a></p>
<p class="toc1"><a href="#/BeyondtheFarthestSuns_3P_MD7">MDIO ECOSYSTEMS</a></p>
<p class="toc1"><a href="#/BeyondtheFarthestSuns_3P_MD8">HARDFOUGHT</a></p>
<p class="toc1"><a href="#/BeyondtheFarthestSuns_3P_MD9">JUDGMENT ENGINE</a></p>
<p class="toc1"><a href="#/BeyondtheFarthestSuns_3P_MD10">APPENDIX: EARLY PREFACES</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BeyondtheFarthestSuns_3P_MD-2.vue?36949ba6